import React, { Component } from 'react';
import { connect } from 'react-redux';
import OpenPreviewProductDetail from '../../../views/app/common/OpenPreviewProductDetail';
import { appActions } from '../../../store/modules/app';

class OpenPreviewProductDetailContainer extends Component {
  render() {
    return <OpenPreviewProductDetail {...this.props} />;
  }
}

const mapDispatchToProps = {
  getProductPreviewData: appActions.getProductPreviewData,
};

export default connect(null, mapDispatchToProps)(OpenPreviewProductDetailContainer);
